import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  waitingConfirmation: false,

  isCategoriesLoaded: false,
  categories: [],
  selectedCategories: [],

  isGiftCardsLoading: false,
  isGiftCardsLoaded: false,
  isGiftCardsLeft: true,
  giftCards: [],

  isPopularGiftCardsLoading: false,
  isPopularGiftCardsLoaded: false,
  isPopularGiftCardsLeft: true,
  popularGiftCards: [],
};

const giftCardsSlice = createSlice({
  name: 'giftCards',
  initialState,
  reducers: {
    receiveGiftCards: (state, { payload }) => ({
      ...state,
      isGiftCardsLoading: false,
      isGiftCardsLoaded: true,
      isGiftCardsLeft: payload.isLeft,
      giftCards: payload.items,
    }),
    addGiftCards: (state, { payload }) => ({
      ...state,
      isGiftCardsLoading: false,
      isGiftCardsLoaded: true,
      isGiftCardsLeft: payload.isLeft,
      giftCards: [...state.giftCards, ...payload.items],
    }),
    receivePopularGiftCards: (state, { payload }) => ({
      ...state,
      isPopularGiftCardsLoading: false,
      isPopularGiftCardsLoaded: true,
      isPopularGiftCardsLeft: payload.isLeft,
      popularGiftCards: payload.items,
    }),
    addPopularGiftCards: (state, { payload }) => ({
      ...state,
      isPopularGiftCardsLoading: false,
      isPopularGiftCardsLoaded: true,
      isPopularGiftCardsLeft: payload.isLeft,
      popularGiftCards: [...state.giftCards, ...payload.items],
    }),
    receiveCategories: (state, { payload }) => ({
      ...state,
      isCategoriesLoaded: true,
      categories: payload,
    }),
    selectCategories: (state, { payload }) => ({
      ...state,
      selectedCategories: payload,
    }),
    setValue: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
    reset: () => initialState,
  },
});

export default giftCardsSlice;
